/** Sustainable Canadian Agricultural Partnership (CAP) programs. */
export const CAP_AGRICULTURE_TASKS = [
  {
    id: 1,
    name: "Program & stream selection",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Match to CAP stream (AgriAssurance, AgriInnovate, AgriScience, AgriMarketing)", completed: false },
      { id: "1-2", name: "Confirm farm/business registration and provincial delivery agent", completed: false },
    ],
  },
  {
    id: 2,
    name: "Project proposal",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Draft project aligned with sustainability or market outcomes", completed: false },
      { id: "2-2", name: "Prepare budget with eligible cost categories", completed: false },
      { id: "2-3", name: "Submit via provincial CAP portal before intake deadline", completed: false },
    ],
  },
  {
    id: 3,
    name: "Implementation & claim",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Execute project per approved work plan", completed: false },
      { id: "3-2", name: "Maintain receipts and activity documentation", completed: false },
      { id: "3-3", name: "Submit final claim and environmental/market reports", completed: false },
    ],
  },
];
